/* eslint-disable class-methods-use-this */

import {getTooltip} from 'Components/tooltip/tooltip.tpl';

const CIRCLE_BADGE_CLASSES = {
    6: 'circle__badge__dark__green',
    8: 'circle__badge__green',
    9: 'circle__badge__light__green'
};

const DEFAULT_BADGE_CLASS = 'circle__badge__default__color';

export const applyHighlightClass = documentType => (documentType === 'PRODUIT' ? 'highlight product-row' : '');
const pastilleClass = pastille => pastille || '<div class="priips__circle__content__empty"></div>';
export const templateClass = (templateLink, type) => (templateLink ? type : '');
const templateLnk = (templateLink, templateAttrs) => (templateLink ? templateAttrs : '');
export const templateUrl = (templateLink, templatelinkDom) => (templateLink ? templatelinkDom : '');

const getLabelName = (labelName, tooltipMessage, tooltipDirection) => `
<div class="priips__item">
    <div class="priips__header__title__whitespace">${labelName}</div>
    <div class="priips__table__tooltip">${tooltipMessage ? getTooltip(tooltipMessage, tooltipDirection) : ''}</div>
</div>
`;

const getCodeIsin = (codeIsin, tooltipMessage2, tooltipDirection2) => `
    <div class="priips__item">
        <div class="priips__header__title__whitespace">${codeIsin}</div>
        <div class="priips__codeisin__tooltip">${tooltipMessage2 ? getTooltip(tooltipMessage2, tooltipDirection2) : ''}</div>
    </div>
`;

const getStatusLabel = (statusLabel, tooltipMessage3, tooltipDirection3) => `
<div class="priips__item">
    <div class="priips__triangle">
        <div class="priips__triangle__up priips__sorted" data-sorted="statut_up" data-disabled="priips_disabled"></div>
        <div class="priips__triangle__down priips__sorted" data-sorted="statut_down"></div>
    </div>
    <div class="priips__header__title">${statusLabel}</div>
    <div class="priips__table__tooltip">${tooltipMessage3 ? getTooltip(tooltipMessage3, tooltipDirection3) : ''}</div>
</div>
`;

const getSfdr = (qualificationSFDR, tooltipMessage4, tooltipDirection4) => `
<div class="priips__item">
    <div class="priips__triangle">
        <div class="priips__triangle__up priips__sorted" data-sorted="sfdr_up"></div>
        <div class="priips__triangle__down priips__sorted" data-sorted="sfdr_down"></div>
    </div>
    <div class="priips__header__title__center">${qualificationSFDR}</div>
    <div class="priips__table__tooltip__center">${tooltipMessage4 ? getTooltip(tooltipMessage4, tooltipDirection4) : ''}</div>
</div>
`;

const getDicDisDici = (dicDisDici, tooltipMessage5, tooltipDirection5) => `
<div class="priips__item">
    <div class="priips__header__title__whitespace">${dicDisDici}</div>
    <div class="priips__table__tooltip">${tooltipMessage5 ? getTooltip(tooltipMessage5, tooltipDirection5) : ''}</div>
</div>
`;

const getProspectus = (prospectus, tooltipMessage6, tooltipDirection6) => `
<div class="priips__item">
    <div class="priips__header__title">${prospectus}</div>
    <div class="priips__table__tooltip">${tooltipMessage6 ? getTooltip(tooltipMessage6, tooltipDirection6) : ''}</div>
</div>
`;

const getRapportsAnnuels = (rapportsAnnuels, tooltipMessage7, tooltipDirection7) => `
<div class="priips__item">
       <div class="priips__header__title__center">${rapportsAnnuels}</div>
       <div class="priips__table__tooltip__center">${tooltipMessage7 ? getTooltip(tooltipMessage7, tooltipDirection7) : ''}</div>
</div>
`;

export const getCircleBadgeClass = value => CIRCLE_BADGE_CLASSES[value] || DEFAULT_BADGE_CLASS;

export default class PriipsTemplate {
    getLoaderDOM({
        displayedProduct
    } = {}) {
        return `<div class="priips__loader__container">
      <div class="priips__loader">
        <span class="priips__loader__message">
            Chargement des documents pour le produit '${displayedProduct}'
        </span>
        <i class="priips__loader__spinner"></i>
      </div>
    </div>`;
    }

    getHeaderDOM({
        displayedProduct,
        documentsListLength
    } = {}) {
        return `<div class="priips__table_header">
                <h2 class="priips__table_header__title">
                  Support ${displayedProduct} : <span>${documentsListLength || '0'} document(s) trouvé(s)
                </h2>
          </div>`;
    }

    getFailedFetchTableDOM({
        displayedProduct
    } = {}) {
        const message = '<i>Le chargement des documents a échoué</i>';

        return `<div class="priips__table_overlay">
      <div class="priips__table_overlay__blurred_content">
        ${this.getHeaderDOM({displayedProduct})}
      </div>
      <div class="priips__table_overlay__clear_content">
        ${message}
      </div>
    </div>`;
    }

    getTableDOM({
        documentsListItems,
        displayedProduct,
        documentsListLength,
        documentListHeaderItem
    } = {}) {
        return `<table class="priips__table">
            <caption class="priips__table_header priips__table_header__title priips__header__caption priips__header__message">
            <div class="priips__item__download__message">
                   <div>Support ${displayedProduct} : <span>${documentsListLength || '0'} document(s) trouvé(s)</span></div>
                    <div class="indication">- Disponibles en cliquant sur les flèches de téléchargement <span class="downloadiconpadding">"<i class="axa-icons axa-icons-download"></i>"</span></div>
            </div>
            </caption>
              <thead>
                <tr>
                  ${this.getRenderTab(documentListHeaderItem)}
                </tr>
              </thead>
              <tbody>
                ${documentsListItems || ''}
              </tbody>
            </table>`;
    }

    getRenderTab(objectHeaderItemDom) {
        const {labelName,
            codeIsin,
            statusLabel,
            qualificationSFDR,
            dicDisDici,
            prospectus,
            rapportsAnnuels,
            tooltipMessage, tooltipDirection,
            tooltipMessage2, tooltipDirection2,
            tooltipMessage3, tooltipDirection3,
            tooltipMessage4, tooltipDirection4,
            tooltipMessage5, tooltipDirection5,
            tooltipMessage6, tooltipDirection6,
            tooltipMessage7, tooltipDirection7} = objectHeaderItemDom;
        return `
                  <th class="priips__table__support priipsth__blue" scope="col">
                  ${getLabelName(labelName, tooltipMessage, tooltipDirection)}</th>
                  <th class="priips__table__code-isin priipsth__blue" scope="col">
                  ${getCodeIsin(codeIsin, tooltipMessage2, tooltipDirection2)}</th>
                  <th class="priips__table__status priipsth__blue" scope="col">
                  ${getStatusLabel(statusLabel, tooltipMessage3, tooltipDirection3)}</th>
                  <th class="priips__table__type priipsth__blue" scope="col">
                  ${getSfdr(qualificationSFDR, tooltipMessage4, tooltipDirection4)}</th>
                  <th class="priips__table__dicdisdici priipsth__blue" scope="col">
                  ${getDicDisDici(dicDisDici, tooltipMessage5, tooltipDirection5)}</th>
                  <th class="priips__table__prospectus priipsth__blue" scope="col">
                  ${getProspectus(prospectus, tooltipMessage6, tooltipDirection6)}</th>
                  <th class="priips__table__rapports__annuels priipsth__blue" scope="col">
                  ${getRapportsAnnuels(rapportsAnnuels, tooltipMessage7, tooltipDirection7)}</th>
                 `;
    }

    getTableItemDOM({
        singleDocument: {
            nom: name,
            isin: code = '',
            statutVente: statut = '',
            noteDurable: pastille,
            kidUrl: dicDisDiciLink,
            rapportAnnuelUrl: rapportsAnnuelsLink,
            prospectusUrl: prospectusLink,
            templateUrl: templateLink,
            type
        } = {}
    } = {}) {
        const dicDisDicilinkAttrs = `href="${dicDisDiciLink}" target="_blank"`;
        const dicDisDicilinkDom = `<div title="télécharger" class="priips__link__center">
      <a class="priips__link priips__tooltip-container priips__table__actions__tooltip_container"
        ${dicDisDicilinkAttrs}>
        <i class="axa-icons axa-icons-download priips__icon-download_blue"></i>
      </a>
    </div>`;
        const rapportsAnnuelsAttrs = `href="${rapportsAnnuelsLink}" target="_blank"`;
        const rapportsAnnuelsDom = `<div title="télécharger" class="priips__link__center">
      <a class="priips__link priips__tooltip-container priips__table__actions__tooltip_container"
        ${rapportsAnnuelsAttrs}>
        <i class="axa-icons axa-icons-download priips__icon-download_blue"></i>
      </a>
    </div>`;
        const prospectusAttrs = `href="${prospectusLink}" target="_blank"`;
        const prospectuslinkDom = `<div title="télécharger" class="priips__link__center">
      <a class="priips__link priips__tooltip-container priips__table__actions__tooltip_container"
        ${prospectusAttrs}>
        <i class="axa-icons axa-icons-download priips__icon-download_blue"></i>
      </a>
    </div>`;
        const templateAttrs = `href="${templateLink}" target="_blank"`;
        const templatelinkDom = `<div title="télécharger">
      <a class="priips__link priips__tooltip-container priips__table__actions__tooltip_container"
        ${templateAttrs}>
        <i class="axa-icons axa-icons-download priips__icon-download_blue"></i>
      </a>
    </div>`;

        return `<tr class="${applyHighlightClass(type)}">
      <th class="priips__table__support" scope="row">
        <span>${name}</span>
      </th>
      <td class="priips__table__code-isin">
        <span>${code}</span>
      </td>
      <td class="priips__table__status">
        ${statut}
      </td>
      <td class="priips__table__type">
      <div class="priips__item">
      <div class="priips__table__sfdr__badge">
      <div class="priips__circle__badge ${getCircleBadgeClass(pastille)}">
      <ScreenReaderOnly>
       <span class="priips__circle__content">${pastilleClass(pastille)}</span>
      </ScreenReaderOnly>
      </div>
      </div>
      <div class="priips__type__padding">
        <a
        ${templateLnk(templateLink, templateAttrs)}>
        <span class="priips__page__table__element__text__content">${templateClass(templateLink, type)}</span>
        </a>
      </div>
      <div class="priips__type__url">
        <span>${templateUrl(templateLink, templatelinkDom)}</span>
      </div>
      </div>
      </td>
      <td class="priips__table__dicdisdici">
        ${dicDisDiciLink ? dicDisDicilinkDom : ''}
      </td>
      <td class="priips__table__prospectus">
        ${prospectusLink ? prospectuslinkDom : ''}
      </td>
      <td class="priips__table__rapports__annuels"">
         ${rapportsAnnuelsLink ? rapportsAnnuelsDom : ''}
      </td>
    </tr>`;
    }
}
